import React from 'react';
import theme from '@/style';
import {goTo, useResponsiveDimensions} from '@/utils';
import Won from '../won/won';
import {LEVELS} from '@/common-pages/bets-detail/components/constant';
import LazyImage from '@/components/basic/image/lazy-image';
import {useTranslation} from 'react-i18next';
import {BasicObject} from '@/types';
export interface KeralaResultProps {
  issueNo?: string;
  drawn?: boolean;
  list: {
    isWin: number;
    lotteryPrice: number;
    wonCode: string;
    level?: string;
    wonAmount?: number;
  }[];
}

const KeralaResult = ({
  list = [],
  issueNo = '',
  drawn = false,
}: KeralaResultProps) => {
  const {i18n} = useTranslation();
  const [showMore, setShowMore] = React.useState(false);

  const targetList = React.useMemo(() => {
    if (list.length > 8 && showMore) {
      return list;
    }
    return list.slice(0, 8);
  }, [showMore, list]);

  const winList = React.useMemo(() => {
    return list.filter(item => item.isWin > 0);
  }, [list]);

  const {width} = useResponsiveDimensions();
  const goToResult = React.useCallback(() => {
    goTo('Result', {
      currentIndex: 1,
      selectType: issueNo,
    } as BasicObject);
  }, [issueNo]);

  return (
    <div className="mt-2">
      {drawn && (
        <button
          type="button"
          onClick={goToResult}
          className="mb-2 flex min-h-12 w-full items-center justify-between bg-[#F4F4F4] px-3">
          <span className="text-sm font-bold text-[#31373D]">
            {issueNo} {i18n.t('label.drawnResults')}
          </span>
          <span className="text-lg text-[#9FA6AC]">›</span>
        </button>
      )}
      <div
        className={`${winList.length > 0 ? 'mb-2' : ''} flex flex-col gap-2`}>
        {winList.map((item, _i) => (
          <Won
            key={_i}
            awardAmount={item.wonAmount ?? 0}
            result={
              <div className="flex items-center">
                {item.level && (
                  <LazyImage
                    occupancy="transparent"
                    width={32}
                    height={32}
                    imageUrl={LEVELS[item.level]}
                  />
                )}
                <span
                  className="text-sm font-bold"
                  style={{color: theme.basicColor.primary}}>
                  {item.wonCode}
                </span>
              </div>
            }
            isBet={false}
          />
        ))}
      </div>
      <div className="flex flex-wrap gap-2">
        {targetList.map((item, _i) => {
          const winColor = item.isWin ? '#F15802' : '#31373D';
          const itemWidth = (width - 48 - 16) / 3;
          return _i === 7 && !showMore ? (
            <button
              type="button"
              onClick={() => setShowMore(true)}
              key={_i}
              className="flex h-9 items-center justify-center rounded-[1.125rem] border border-[#9FA5AC] bg-white font-bold"
              style={{width: itemWidth}}>
              <span>{i18n.t('home.label.viewAll')}</span>
            </button>
          ) : (
            <div
              key={_i}
              className={`flex h-9 items-center justify-center rounded-[1.125rem] font-bold ${
                item.isWin > 0
                  ? 'border border-[#F15802] bg-white'
                  : 'bg-[#F6F7FB]'
              }`}
              style={{width: itemWidth}}>
              <span style={{color: winColor}}>{item.wonCode}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default KeralaResult;
